export default __webpack_public_path__ + "static/media/ambassador_network_new_image.77fd47b3.png";